import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Menu } from 'domain/models';

interface IMenuState {
  menu: Menu[];
}

interface IPayloadMenu extends PayloadAction<Menu[]> {}

const initialState: IMenuState = {
  menu: [],
};

export const MenuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    loadMenu: (state, action: IPayloadMenu) => {
      state.menu = action.payload;
    },
  },
});

export const { loadMenu } = MenuSlice.actions;
